(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState,
  useCallback
} = React;
const {
  trackListChanges,
  trackAppPauseNotifcation
} = svs.myProfile.react.shared.tracking;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';
const Checkbox = svs.ui.reactForm.Checkbox;
const {
  Card,
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  Radio
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  getplayerCustomizedSettingsAsync,
  putCustomersProductTogglesAsync,
  getPauseData,
  putPauseData,
  removePauseData
} = svs.myProfile.react.pages.notifications.appNotifications.appNotificationsService;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  showSettingsTechnicalError,
  confirmRemovePauseDialog,
  pauseRemovedDialog,
  pauseAddedDialog
} = svs.myProfile.react.shared.dialogs;
const {
  titles,
  icons,
  productNotificationSetting,
  pausAlternatives,
  pauseNotifications
} = svs.myProfile.constants;
const AppNotifications = () => {
  const [loading, setLoadingState] = useState(true);
  const [notificationToggles, setNotificationToggles] = useState([]);
  const [pause, setPause] = useState();
  const [selectedPause, setSelectedPause] = useState(120);
  const getPreferenceData = useCallback(async () => {
    let productToggles = {};
    let productTogglesArray = [];
    let hasNotificationDevices = false;
    const {
      error,
      preferences
    } = await getplayerCustomizedSettingsAsync();
    const {
      errors,
      pauseData
    } = await getPauseData();
    if (preferences) {
      if (preferences.notificationDevices) {
        const notificationDevices = JSON.parse(preferences.notificationDevices);
        hasNotificationDevices = Array.isArray(notificationDevices) && Boolean(notificationDevices.length);
      }
      if (preferences.notificationToggles) {
        productToggles = JSON.parse(preferences.notificationToggles);
      }
    }
    if (hasNotificationDevices && productNotificationSetting) {
      productTogglesArray = productNotificationSetting.productNotificationSetting.filter(product => product.productId !== 33).map(product => {
        const prodName = svs.utils.products.getProdName(product.productId);
        if (Object.prototype.hasOwnProperty.call(productToggles, prodName)) {
          product.active = productToggles[prodName];
        }
        return product;
      });
    } else if (!hasNotificationDevices && productToggles.length) {
      productToggles.length = 0;
    }
    setNotificationToggles(productTogglesArray);
    setPause(pauseData);
    if (error || errors) {
      showSettingsTechnicalError('På grund av ett tekniskt fel kan vi just nu inte visa dina inställningar. Vänligen försök igen senare.');
    }
    setLoadingState(false);
  }, []);
  useEffect(() => {
    getPreferenceData();
  }, [getPreferenceData]);
  const updateState = savedToggles => {
    const copyOfToggleArray = JSON.parse(JSON.stringify(notificationToggles));
    for (const toggle of savedToggles) {
      const thisToggleInArrayCopy = copyOfToggleArray.find(to => to.productName === toggle.productName);
      thisToggleInArrayCopy.active = toggle.active;
    }
    setNotificationToggles(copyOfToggleArray);
  };

  const saveToggle = async toggle => {
    putCustomersProductTogglesAsync({
      productName: toggle.productValue,
      toggleOn: !toggle.active
    });
  };
  const handleClickToggle = async product => {
    const response = await saveToggle(product);
    if (response !== null && response !== void 0 && response.error) {
      showSettingsTechnicalError('Ett fel inträffade när dina notifieringsinställningar skulle sparas, försök igen senare.');
      return null;
    }
    const updatedData = notificationToggles.map(toggle => toggle.productId === product.productId ? _objectSpread(_objectSpread({}, toggle), {}, {
      active: !product.active
    }) : toggle);
    updateState(updatedData);
    trackListChanges(updatedData, notificationToggles, 'app-notifications', titles.APP);
  };
  const handleOnChangePause = useCallback(pause => {
    setSelectedPause(pause);
  }, [setSelectedPause]);
  const handleClickSetPause = async pause => {
    const response = await putPauseData({
      silentMinutes: pause.silentMinutes,
      untilMorning: pause.untilMorning
    });
    if (response !== null && response !== void 0 && response.error) {
      showSettingsTechnicalError('Ett fel inträffade när din paus skulle sparas, försök igen senare.');
      return null;
    }
    let pausedUntil;
    let untilNextDay;
    if (pause.untilMorning) {
      pausedUntil = dateFns.addDays(new Date(), 1);
      pausedUntil = dateFns.setHours(pausedUntil, 8);
      pausedUntil = dateFns.setMinutes(pausedUntil, 0);
      untilNextDay = true;
    } else {
      pausedUntil = dateFns.addMinutes(new Date(), pause.silentMinutes);
      untilNextDay = false;
    }
    pauseAddedDialog(pausedUntil, untilNextDay);
    setPause(pausedUntil);
    trackAppPauseNotifcation(pause.pauseName, pauseNotifications.pause, titles.APP);
  };
  const handleClickRemovePause = async () => {
    const response = await removePauseData();
    if (response !== null && response !== void 0 && response.error) {
      showSettingsTechnicalError('Ett fel inträffade när din paus skulle tas bort, försök igen senare.');
      return null;
    }
    pauseRemovedDialog();
    setPause();
    trackAppPauseNotifcation(pauseNotifications.noPause, pauseNotifications.unPause, titles.APP);
  };
  return React.createElement("div", null, !loading && !isPnp && notificationToggles.length !== 0 && React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.APP,
    title: titles.APP
  }), React.createElement("p", null, "F\xE5 notiser via appen vid viktiga h\xE4ndelser under matchen, eller loppets, g\xE5ng. V\xE4lj vilka spel du \xF6nskar notiser fr\xE5n."), notificationToggles.map(product => React.createElement(Checkbox, {
    checked: product.active,
    key: product.productId,
    onChange: () => handleClickToggle(product)
  }, product.productName)), pause ? React.createElement("div", {
    className: "margin-v-1"
  }, React.createElement(Card, null, React.createElement(CardBody, null, React.createElement("h5", {
    className: "card-title"
  }, "Dina notiser \xE4r pausade"), React.createElement("p", {
    className: "card-text"
  }, "Notiser kommer \xE5ter b\xF6rja skickas klockan", ' ', dateFns.format(new Date(pause), 'HH:mm'), "."), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: isPnp,
    onClick: () => confirmRemovePauseDialog(handleClickRemovePause),
    size: 300,
    transparent: true
  }, "Ta bort paus")))) : React.createElement("div", {
    className: "margin-v-1"
  }, React.createElement(PdCard, null, React.createElement(WhiteCardHeader, null, "Pausa notiser"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement("p", null, "V\xE4lj hur l\xE4nge du vill pausa notiser i appen.")), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, pausAlternatives.map(pause => React.createElement(Radio, {
    checked: pause.silentMinutes === selectedPause,
    key: pause.silentMinutes,
    onChange: () => handleOnChangePause(pause.silentMinutes),
    value: pause.silentMinutes
  }, pause.pauseName)), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    onClick: () => handleClickSetPause(pausAlternatives.find(_ref => {
      let {
        silentMinutes
      } = _ref;
      return silentMinutes === selectedPause;
    })),
    size: 300
  }, "Pausa notiser"))))));
};
svs.myProfile.react.pages.notifications.appNotifications.AppNotifications = AppNotifications;

 })(window);